import React from 'react';
import { SiteHeader } from './SiteHeader';
import { SiteFooter } from './SiteFooter';
import { BottomTabNav } from './BottomTabNav';
import { WhatsAppButton } from './WhatsAppButton';

export const PublicLayout = ({ children }) => (
  <div className="min-h-screen flex flex-col bg-[hsl(var(--sb-bg))]">
    <SiteHeader />
    <main className="flex-1 pb-20 lg:pb-0">{children}</main>
    <SiteFooter />
    <BottomTabNav />
    <WhatsAppButton />
  </div>
);
